import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import '../../../global_components/KenTable/index.scss';
import { Button } from '@material-ui/core';

export default function FacultyTable({
  data,
  setFacultyName,
  handlefacultyDialog,
  selectFaculty,
  setSelectFaculty,
  rowFaculty,
}) {
  const addFacultyName = (name) => {
    setFacultyName(name.props.children[2]);
    // const newFaculty = [...selectFaculty];

    handlefacultyDialog();
  };
  return (
    <table className="zq-table-wrap" id="table-to-xls">
      <thead className="zq-table-heading">
        <tr>
          <th align="left">NAME</th>
          <th align="left">PHONE</th>
          <th align="left">EMAIL</th>
          <th align="left">TYPE</th>
          <th align="left"> AVAILABILITY</th>
          <th align="left"> Action</th>
        </tr>
      </thead>
      <tbody className="zq-table-body">
        {data.map((row, index) => (
          <tr key={row.name}>
            <TableCell align="left"> {row.name}</TableCell>
            <TableCell align="left">{row.phone}</TableCell>
            <TableCell align="left">{row.email}</TableCell>
            <TableCell align="left">{row.type}</TableCell>
            <TableCell align="left">{row.availability}</TableCell>
            <TableCell align="left">
              {' '}
              <Button
                variant="contained"
                color="primary"
                onClick={(e) => addFacultyName(row.name, index)}
                // style={{ marginLeft: '180px', padding: '6px 24px 6px 24px' }}
              >
                Add Faculty
              </Button>
            </TableCell>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
